import React, { useEffect, useState } from 'react';
import Notification from '../../Notification';
import { Link, useNavigate } from 'react-router-dom';
import { Dropdown } from 'antd';
import Cookies from 'js-cookie';
import { useDispatch } from 'react-redux';
import {
  SET_IS_API_CALLED,
  SET_IS_API_CALLED_FINISHED,
} from '../../../store/features/loadingSlice';
import { notificationApi } from '../../../Services/notification';
import { logout } from '../../../Services/auth';

// import hydrosmartIcon from "public/assets/HYDROSMART Icon-02.png"

function LayoutHeader() {
  const [collapse, setCollapse] = useState(false);
  const [notificationData, setNotificationData] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = async () => {
    dispatch(SET_IS_API_CALLED('Log Out'));
    const res = await logout();
    if (res?.status >= 200 && res?.status < 300) {
      Cookies.remove('jwtToken');
      localStorage.clear();
      navigate('/logout');
    } else {
    }

    dispatch(SET_IS_API_CALLED_FINISHED());
  };

  const viewMoreData = () => {
    dispatch(SET_IS_API_CALLED('Log Out'));
    notificationApi({
      pageSize: 20,
      pageIndex: notificationData?.pageIndex + 1,
      sort: 0,
    }).then((res) => {
      setNotificationData({
        ...res?.data,
        items: [...notificationData?.items, ...res?.data?.items],
      });
    });
    dispatch(SET_IS_API_CALLED_FINISHED());
  };

  useEffect(() => {
    notificationApi({
      pageSize: 20,
      pageIndex: 1,
      sort: 0,
    }).then((res) => {
      setNotificationData(res?.data);
    });
  }, []);

  return (
    <div className="flex h-[103px] items-center justify-between overflow-hidden bg-white pl-6 pr-10 shadow-md">
      <div className="w-3/12 text-3xl font-normal">
        <img src={'/assets/HYDROSMART Icon-02.png'} alt="Logo" />
      </div>
      <div className="flex items-center gap-5 text-medium-grey">
        <button
          className="text-lg font-bold hover:text-medium-blue-200"
          onClick={() => {
            handleLogout();
          }}
        >
          Log Out
        </button>
        <Dropdown
          dropdownRender={() => (
            <div className="w-[215px] bg-white py-[5px] shadow-md">
              <Link to={'/role-management/update-profile'}>
                <div className="py-[17px] ps-[31px] text-[18px] font-normal text-medium-blue">
                  Update Profile
                </div>
              </Link>
              <div className="border-b-[1px]"></div>
              <Link to={'/setting/change-password'}>
                <div className="py-[17px] ps-[31px] text-[18px] font-normal text-medium-blue">
                  Change Password
                </div>
              </Link>
            </div>
          )}
          placement="bottomRight"
        >
          <div>
            <img
              src={'/assets/icon-profile.svg'}
              alt="Profile"
              className="h-[46.5px] w-[46.5px] cursor-pointer"
            />
          </div>
        </Dropdown>
        <button
          className={`relative ${collapse ? 'text-medium-blue-200' : ''}`}
          onClick={() => {
            setCollapse(!collapse);
          }}
        >
          <img
            src={'/assets/icon-notification.svg'}
            alt="Setting"
            className="h-[28.1px] w-[22.4px]"
          />

          <span className="absolute -right-2 -top-2 m-auto flex h-5 w-5 items-center justify-center rounded-full bg-medium-blue-100 text-[10px] text-white">
            {notificationData?.items?.length}
          </span>
        </button>
        {collapse && (
          <Notification
            setCollapse={setCollapse}
            notificationData={notificationData}
            viewMoreData={viewMoreData}
          />
        )}
      </div>
    </div>
  );
}

export default LayoutHeader;
